import FaqComponent from '../components/UI/Faq';
import Steps from '../components/UI/Steps';
import CallToActionBox from '../components/UI/CallToActionBox';
import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from "react-i18next";

const Faq = () => {
    const { t } = useTranslation();
    return (
        <>
            <Helmet>
                <title>{t("seo.title.faq")}</title>
                <meta name="description" content={t('seo.description.faq')} />
                <meta property="og:title" content={t('seo.title.faq')} />
                <meta property="og:description" content={t('seo.description.faq')} />
            </Helmet>
            <FaqComponent />
            <CallToActionBox />
        </>
    );
};

export default Faq;
